import pipe from "../../lib/core/functional/pipe";
import { processParticleWrapperAttributes } from "./common";
import { slideshowTemplate, thumbnailTemplate } from "./templates";

function processSlidesWrapper(context) {
    const { container, id, postId, headline, mediaHtml } = context;
    const slideWrapperSelector = ".rebellt-item";
    const mediaHtmlWrapper = ".listicle-slideshow-media-html";

    const slideContainer = container.querySelector(slideWrapperSelector);
    slideContainer.setAttribute("data-index", id);
    slideContainer.setAttribute("data-post-id", postId);
    slideContainer.querySelector("h3").innerHTML = headline || "";

    container.querySelector(mediaHtmlWrapper).innerHTML = mediaHtml || "";

    return context;
}

function processSlideCaptions(context) {
    const { container, caption, credit } = context;
    container.querySelector(".media-photo-credit").innerHTML = credit || "";
    container.querySelector(".media-caption").innerHTML = caption || "";
    return context;
}

function processAdsScript(context) {
    const { container, adsConfig, postId } = context;
    const adsConfigNode = container.querySelector('script[type="application/json"]');
    adsConfigNode.innerText = JSON.stringify(adsConfig);
    adsConfigNode.id = `slideshow-ads-context-${postId}`;
    return context;
}

function processThumbnails(context) {
    const { container, slides, href, postId } = context;
    const thumbsContainer = container.querySelector(".listicle-slideshow__thumbnails");

    slides.forEach((slide, idx) => {
        const thumb = thumbnailTemplate.getElement();
        const dataId = `slide-html-${postId}-${idx}`;
        if (slide.href === href) {
            thumb.classList.add("active");
        }
        thumb.setAttribute("data-href", slide.href);
        thumb.setAttribute("data-post-id", postId);
        thumb.setAttribute("data-media-html-id", dataId);
        const htmlContainer = thumb.querySelector('script[type="application/json"]');
        htmlContainer.id = dataId;
        htmlContainer.innerText = slide.mediaHtml;

        const image = thumb.querySelector("div.image");
        image.setAttribute("data-runner-img-hd", slide.thumb);

        thumbsContainer.appendChild(thumb);
    });
    return context;
}

export default function addAssemblerSlideshow(particleConfig, settings) {
    const { postId } = settings;
    const { id, slides, adsConfig } = particleConfig;
    const [activeSlide] = slides;

    const container = slideshowTemplate.getElement();
    processParticleWrapperAttributes(container, particleConfig);
    const context = {
        container,
        id,
        postId,
        adsConfig,
        slides,
        ...activeSlide,
    };

    pipe(processSlidesWrapper, processSlideCaptions, processAdsScript, processThumbnails)(context);

    return container;
}
